import React, { FC } from 'react';

const AccountDataButton: FC<{ onClick?: React.MouseEventHandler<HTMLButtonElement> }> = ({ children, onClick }) => {
  return (
    <button data-testid="button-account-data" className="account-data-sections__button" type="button" onClick={onClick}>
      <div className="text">{children}</div>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.66576 14.0091C4.99243 14.3358 5.51909 14.3358 5.84576 14.0091L11.3858 8.46914C11.6458 8.20914 11.6458 7.78914 11.3858 7.52914L5.84576 1.98914C5.51909 1.66247 4.99243 1.66247 4.66576 1.98914C4.3391 2.31581 4.3391 2.84247 4.66576 3.16914L9.49243 8.00247L4.65909 12.8358C4.33909 13.1558 4.3391 13.6891 4.66576 14.0091Z"
          fill="black"
        />
      </svg>
    </button>
  );
};

AccountDataButton.defaultProps = {
  onClick: undefined,
};
export default AccountDataButton;
